export default "__VITE_PUBLIC_ASSET__3b513ea5__"